import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { Col, Row, Card } from '@themesberg/react-bootstrap'
import { Context } from '../Reward'
import { getSummaryReward } from '../../../../controller/api/__classic__/reward'
import { useCookies } from 'react-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrophy, faHandHoldingUsd, faPercentage, faWallet } from '@fortawesome/free-solid-svg-icons'
import { formatNumber } from '../../../../helper/helper'

const _Summary = () => {

  const { state } = useContext(Context);

  const [cookies] = useCookies(['lottmekong'])

  const [summary, setSummary] = useState({
    gross: 0,
    tax: 0,
    fee: 0,
    net: 0,
  })

  const getSummaryFunc = useCallback(async () => {

    let phone = state.filter.phone

    if (phone.indexOf('MB') < 0) {
      phone = phone.replace('0', '+84')
    }

    const response = await getSummaryReward(cookies.lottmekong, {
      from: state.filter.from,
      to: state.filter.to,
      phone: phone
    })

    if (response) {
      const res = {
        gross: response.gross,
        tax: response.tax,
        fee: response.fee,
        net: response.net
      }
      setSummary(res || {})
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.phone])

  const listSumary = useMemo(() => {
    return (
      <>
        <Col md={3} sm={12} className="mb-3 mb-md-0">
          <Card border="light" className="shadow-sm h-100">
            <Card.Body className="d-flex align-items-center">
              <div className="icon icon-shape icon-md icon-shape-primary rounded me-3">
                <FontAwesomeIcon icon={faTrophy} />
              </div>
              <div>
                <h6 className="fw-normal text-muted mb-1">Giải thưởng</h6>
                <h4 className="fw-bold mb-0 text-primary">{formatNumber(summary.gross)}</h4>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={12} className="mb-3 mb-md-0">
          <Card border="light" className="shadow-sm h-100">
            <Card.Body className="d-flex align-items-center">
              <div className="icon icon-shape icon-md icon-shape-danger rounded me-3">
                <FontAwesomeIcon icon={faHandHoldingUsd} />
              </div>
              <div>
                <h6 className="fw-normal text-muted mb-1">Thuế</h6>
                <h4 className="fw-bold mb-0 text-danger">{formatNumber(summary.tax)}</h4>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={12} className="mb-3 mb-md-0">
          <Card border="light" className="shadow-sm h-100">
            <Card.Body className="d-flex align-items-center">
              <div className="icon icon-shape icon-md icon-shape-warning rounded me-3">
                <FontAwesomeIcon icon={faPercentage} />
              </div>
              <div>
                <h6 className="fw-normal text-muted mb-1">Phí</h6>
                <h4 className="fw-bold mb-0 text-warning">{formatNumber(summary.fee)}</h4>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={12}>
          <Card border="light" className="shadow-sm h-100">
            <Card.Body className="d-flex align-items-center">
              <div className="icon icon-shape icon-md icon-shape-success rounded me-3">
                <FontAwesomeIcon icon={faWallet} />
              </div>
              <div>
                <h6 className="fw-normal text-muted mb-1">Thực nhận</h6>
                <h4 className="fw-bold mb-0 text-success">{formatNumber(summary.net)}</h4>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </>
    )
  }, [summary])

  useEffect(() => {
    getSummaryFunc()
  }, [getSummaryFunc, state.filterPressCount])

  return (
    <Row className="mb-3">
        {listSumary}
    </Row>
  );
};

export default React.memo(_Summary)